import { useEffect, useState } from 'react';
import { Container, Grid, Switch, Box, TextField, Button } from '@mui/material';
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { onAuthStateChanged, signOut } from 'firebase/auth';
import { auth } from '../../../config/firebase';
import { top, getCollectionsComplete, updateDataSimple, setData } from '../../../assets/js/functions';
import { reporteUsuarios, reporteAsistenciaa, reporteChat } from '../../../assets/js/reportes';
import BabyChangingStationIcon from '@mui/icons-material/BabyChangingStation';
import CloudDoneIcon from '@mui/icons-material/CloudDone';
import Swal from 'sweetalert2';
import './styles.scss';

export default function Dev() {
  const [listo, setListo] = useState(false);

  // Switches
  const [streamingActivo, setStreamingActivo] = useState(false);
  const [activarIframe, setActivarIframe] = useState(false);

  // Inputs con estado de edición
  const [targetDate, setTargetDate] = useState(dayjs());
  const [chatID, setChatID] = useState('');          const [editingChatID, setEditingChatID] = useState(false);
  const [adminsChat, setAdminsChat] = useState('');  const [editingAdminsChat, setEditingAdminsChat] = useState(false);
  const [idIframe, setIdIframe] = useState('');      const [editingIdIframe, setEditingIdIframe] = useState(false);
  const [video1, setVideo1] = useState('');          const [editingVideo1, setEditingVideo1] = useState(false);
  const [video2, setVideo2] = useState('');          const [editingVideo2, setEditingVideo2] = useState(false);
  const [video3, setVideo3] = useState('');          const [editingVideo3, setEditingVideo3] = useState(false);
  const [video4, setVideo4] = useState('');          const [editingVideo4, setEditingVideo4] = useState(false);
  const [videoSelecc, setVideoSelecc] = useState('');const [editingVideoSelecc, setEditingVideoSelecc] = useState(false);
  const [msj1, setMsj1] = useState('');             const [editingMsj1, setEditingMsj1] = useState(false);
  const [msj2, setMsj2] = useState('');             const [editingMsj2, setEditingMsj2] = useState(false);
  const [msj3, setMsj3] = useState('');             const [editingMsj3, setEditingMsj3] = useState(false);
  const [numMsj, setNumMsj] = useState('');         const [editingNumMsj, setEditingNumMsj] = useState(false);

  // Chat
  const [botonLimpiarChat1, setBotonLimpiarChat1] = useState(false);
  const [botonLimpiarChat2, setBotonLimpiarChat2] = useState(false);

  const meses = [
      'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
      'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
    ];

  const mesActual = meses[new Date().getMonth()];


  useEffect(() => {
    top();
    const unsub = onAuthStateChanged(auth, async (user) => {
      if (!user) { window.location.replace('/'); return; }
      const userData = await getCollectionsComplete(`usuarios/${user.uid}`);
      if (userData?.rol !== 'dev') { window.location.replace('/streaming'); return; }
      await cargarTodo();
      setListo(true);
    });
    return () => unsub();
  }, []);

  const cargarTodo = async () => {
    const [
      activo, iframe, chatid, adminsChatVal, idIframeVal,
      v1, v2, v3, v4, server,
      m1, m2, m3, numM, fecha,
      dataDia1, dataDia2,
    ] = await Promise.all([
      getCollectionsComplete('dev/streamingActivo'),
      getCollectionsComplete('dev/activarIframe'),
      getCollectionsComplete('dev/chatid'),
      getCollectionsComplete('dev/adminsChat'),
      getCollectionsComplete('dev/idIframe'),
      getCollectionsComplete('dev/video1'),
      getCollectionsComplete('dev/video2'),
      getCollectionsComplete('dev/video3'),
      getCollectionsComplete('dev/video4'),
      getCollectionsComplete('dev/streamingServer'),
      getCollectionsComplete('dev/mensajeEventoCerrado1'),
      getCollectionsComplete('dev/mensajeEventoCerrado2'),
      getCollectionsComplete('dev/mensajeEventoCerrado3'),
      getCollectionsComplete('dev/numMensajeEventoCerrado'),
      getCollectionsComplete('dev/targetDate'),
      getCollectionsComplete('chat/dia1'),
      getCollectionsComplete('chat/dia2'),
    ]);

    setStreamingActivo(activo || false);
    setActivarIframe(iframe || false);
    setChatID(chatid || '');
    setAdminsChat(adminsChatVal || '');
    setIdIframe(idIframeVal || '');
    setVideo1(v1 || '');
    setVideo2(v2 || '');
    setVideo3(v3 || '');
    setVideo4(v4 || '');
    setVideoSelecc(server || '');
    setMsj1(m1 || '');
    setMsj2(m2 || '');
    setMsj3(m3 || '');
    setNumMsj(numM || '');
    if (fecha) setTargetDate(dayjs(fecha));
    setBotonLimpiarChat1(dataDia1 && Object.keys(dataDia1).length > 0);
    setBotonLimpiarChat2(dataDia2 && Object.keys(dataDia2).length > 0);
  };

  const cerrarSesion = async () => {
    await signOut(auth);
    sessionStorage.clear();
    window.location.replace('/');
  };

  const limpiarChat = (dia) => {
    Swal.fire({
      title: '¿Estás seguro?',
      text: `Esto eliminará todos los mensajes del chat dia${dia}.`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí, limpiar',
      cancelButtonText: 'Cancelar',
    }).then((result) => {
      if (result.isConfirmed) {
        const año = new Date().getFullYear();
        setData(`chat/`, `dia${dia}`, {
          lydo61at: {
            fechaDeRegistro: año,
            id: 'lydo61at',
            idIncrement: 1,
            nombre: 'Staff',
            text: `Bienvenidos a la transmisión en vivo día ${dia}.`,
            user: '000000',
            visible: true,
          },
        }).then(() => {
          Swal.fire('¡Listo!', 'Se ha limpiado el chat.', 'success');
          dia === 1 ? setBotonLimpiarChat1(false) : setBotonLimpiarChat2(false);
        });
      }
    });
  };

  // Helper para inputs con Enter-para-guardar
  const inputProps = (label, value, setter, editingSetter, devKey) => ({
    label,
    fullWidth: true,
    variant: 'filled',
    value: value || '',
    onChange: (e) => { setter(e.target.value); editingSetter(true); },
    onKeyDown: (e) => {
      if (e.key === 'Enter') {
        updateDataSimple('dev', { [devKey]: e.target.value });
        editingSetter(false);
        e.target.blur();
      }
    },
  });

  if (!listo) return null;

  return (
    <div className='dev'>
      <div className='dev-header'>
        <h2>Panel Dev</h2>
        <Button variant='outlined' size='small' onClick={cerrarSesion}>Cerrar sesión</Button>
      </div>
      <Container maxWidth='lg'>
        <br />

        {/* FECHA TARGET */}
        <p className='dev-label'>Fecha del evento:</p>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            value={targetDate}
            onChange={(date) => {
              if (date) {
                setTargetDate(date);
                updateDataSimple('dev', { targetDate: date.startOf('day').format('YYYY-MM-DD') });
              }
            }}
          />
        </LocalizationProvider>
        <br /><br />

        {/* SWITCHES */}
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <table className='dev-table'>
              <tbody>
                <tr>
                  <td>Activar streaming</td>
                  <td><Switch checked={streamingActivo} onChange={(e) => { setStreamingActivo(e.target.checked); updateDataSimple('dev', { streamingActivo: e.target.checked }); }} /></td>
                </tr>
                <tr>
                  <td>Activar Iframe (en lugar de ReactPlayer)</td>
                  <td><Switch checked={activarIframe} onChange={(e) => { setActivarIframe(e.target.checked); updateDataSimple('dev', { activarIframe: e.target.checked }); }} /></td>
                </tr>
              </tbody>
            </table>
          </Grid>
        </Grid>
        <br />

        {/* INPUTS */}
        {[
          ['Chat ID', chatID, setChatID, setEditingChatID, editingChatID, 'chatid'],
          ['Admins Chat (separados por coma)', adminsChat, setAdminsChat, setEditingAdminsChat, editingAdminsChat, 'adminsChat'],
          ['ID iframe', idIframe, setIdIframe, setEditingIdIframe, editingIdIframe, 'idIframe'],
          ['Video 1', video1, setVideo1, setEditingVideo1, editingVideo1, 'video1'],
          ['Video 2', video2, setVideo2, setEditingVideo2, editingVideo2, 'video2'],
          ['Video 3', video3, setVideo3, setEditingVideo3, editingVideo3, 'video3'],
          ['Video 4', video4, setVideo4, setEditingVideo4, editingVideo4, 'video4'],
          ['Video activo (1-4)', videoSelecc, setVideoSelecc, setEditingVideoSelecc, editingVideoSelecc, 'streamingServer'],
          ['Mensaje evento cerrado 1', msj1, setMsj1, setEditingMsj1, editingMsj1, 'mensajeEventoCerrado1'],
          ['Mensaje evento cerrado 2', msj2, setMsj2, setEditingMsj2, editingMsj2, 'mensajeEventoCerrado2'],
          ['Mensaje evento cerrado 3', msj3, setMsj3, setEditingMsj3, editingMsj3, 'mensajeEventoCerrado3'],
          ['Número del mensaje activo (1-3)', numMsj, setNumMsj, setEditingNumMsj, editingNumMsj, 'numMensajeEventoCerrado'],
        ].map(([label, value, setter, editingSetter, editing, devKey]) => (
          <Box key={devKey} mb={2}>
            <Grid container spacing={1} alignItems='center'>
              <Grid item md={6} xs={10}>
                <TextField {...inputProps(label, value, setter, editingSetter, devKey)} />
              </Grid>
              <Grid item xs={2}>
                {editing ? <BabyChangingStationIcon style={{ color: '#d32f2f' }} /> : <CloudDoneIcon style={{ color: '#00a980' }} />}
              </Grid>
            </Grid>
          </Box>
        ))}

        <br />

        {/* BOTONES */}
        <Grid container spacing={2}>
          <Grid item xs={12} md={4}>
            <Button fullWidth variant='contained' onClick={() => limpiarChat(1)} disabled={!botonLimpiarChat1}>
              Limpiar Chat dia1
            </Button>
          </Grid>
          <Grid item xs={12} md={4}>
            <Button fullWidth variant='contained' onClick={() => limpiarChat(2)} disabled={!botonLimpiarChat2}>
              Limpiar Chat dia2
            </Button>
          </Grid>
          <Grid item xs={12} md={4}>
            <Button fullWidth variant='contained' color='success' onClick={() => reporteUsuarios()}>
              Reporte usuarios
            </Button>
          </Grid>
          <Grid item xs={12} md={4}>
            <Button fullWidth variant='contained' color='success' onClick={() => reporteAsistenciaa(mesActual)}>
              Reporte asistencia
            </Button>
          </Grid>
          <Grid item xs={12} md={4}>
            <Button fullWidth variant='contained' color='info' onClick={() => reporteChat()}>
              Reporte chat
            </Button>
          </Grid>
        </Grid>
        <br /><br /><br />
      </Container>
    </div>
  );
}
